export var routes = {
  admin: '/admin',
  edit_profile: '/me/edit/profile',
  edit_password: '/me/edit/password',
  event: "/event",
  events: '/events',
  appentity: "/appentity",
  permission: "/permission",
  userrole: "/userrole",
  orguser: "/orguser",
  system: "/system",
  systems: "/systems",
  campus: "/campus",
  campuses: "/campuses",
  event_category: "/event-category",
  event_categories: "/event-categories"
};